export default __webpack_public_path__ + "static/media/dpu4045yeh.bd39a2e0.webp";